import { Container, Grid } from "@mui/material";
import AvailabilityTicketForm from "../../../components/view/availability/availability-ticket-form.jsx";
import FlightPassengers from "../../passengers/flight-passengers.jsx";
import IntFlightPassengers from "../../passengers/int-flight-passengers.jsx";

function FlightAutomaticReservation() {
    const generalInformation = JSON.parse(sessionStorage.getItem("generalInformation")) || {};
    const { isFlightInternational } = generalInformation;

    return (
        <Container maxWidth="lg">
            <AvailabilityTicketForm type="reserve" />
            <Grid pt={{ md: 8, xs: 0 }}>{isFlightInternational ? <IntFlightPassengers /> : <FlightPassengers />}</Grid>
        </Container>
    );
}
export default FlightAutomaticReservation;
